package app.components

import app.CustomRouter
import app.Routes
import dev.fritz2.core.*

fun RenderContext.sidebarNavigation(projectId: String) {
    div("basis-2/12 border rounded-md shadow-md my-4 p-4 shrink-0 min-h-80 dark:bg-gray-800 dark:border-gray-700") {
        CustomRouter.select(key = "route").render { (page, _) ->
            nav("w-full flex flex-col gap-2 dark:text-white") {
                a("cursor-pointer hover:underline dark:text-gray-200 ${if (page == Routes.PROJECT_DETAIL) "underline" else ""}") {
                    +"Details"
                    clicks handledBy {
                        CustomRouter.projectDetail(mapOf(
                            "route" to Routes.PROJECT_DETAIL,
                            Routes.Params.PROJECT_ID to projectId,
                        ))
                    }
                }
                a("cursor-pointer hover:underline dark:text-gray-200 ${if (page == Routes.PROJECT_STEP) "underline" else ""}") {
                    +"Steps"
                    clicks handledBy {
                        CustomRouter.projectStep(mapOf(
                            "route" to Routes.PROJECT_STEP,
                            Routes.Params.PROJECT_ID to projectId,
                        ))
                    }
                }
                a("cursor-pointer hover:underline dark:text-gray-200 ${if (page == Routes.RELEASES) "underline" else ""}") {
                    +"Releases"
                    clicks handledBy {
                        CustomRouter.releases(mapOf(
                            "route" to Routes.RELEASES,
                            Routes.Params.PROJECT_ID to projectId,
                        ))
                    }
                }
                a("cursor-pointer hover:underline dark:text-gray-200 ${if (page == Routes.ROLLOUTS) "underline" else ""}") {
                    +"Rollouts"
                    clicks handledBy {
                        CustomRouter.rollouts(mapOf(
                            "route" to Routes.ROLLOUTS,
                            Routes.Params.PROJECT_ID to projectId,
                        ))
                    }
                }
                a("cursor-pointer hover:underline dark:text-gray-200 ${if (page == Routes.PROJECT_VARIABLE) "underline" else ""}") {
                    +"Variables"
                    clicks handledBy {
                        CustomRouter.projectVariables(mapOf(
                            "route" to Routes.PROJECT_VARIABLE,
                            Routes.Params.PROJECT_ID to projectId,
                        ))
                    }
                }
            }
        }
    }
}
